import React from "react";

import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const EditIcon: FC<IconProps> = ({ ...props }) => (
    <BaseIcon {...props}>
        <path d="m12.197 23.567 14.83-14.831a2 2 0 0 0 0-2.828l-2.12-2.122a2 2 0 0 0-2.83 0l-14.83 14.83v3.95a1 1 0 0 0 1 1h3.95Zm-2.95-4.122L19.64 9.053l2.121 2.122-10.392 10.392h-2.12v-2.122ZM21.053 7.64l2.439-2.44 2.121 2.122-2.439 2.438-2.12-2.12ZM3 27a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z" />
    </BaseIcon>
);
